import { Icon, Intent, EditableText } from "./externals";
import React from "react";
export const ListWithAction = ({ label, onClick, onSelected, selected, onConfirm, enabled, }) => {
    return (React.createElement("li", { onClick: onSelected, className: `focus-actionableList ${selected ? "focus-actionableList-selected" : ""} ` },
        onConfirm ? (React.createElement(EditableText, { onConfirm: onConfirm, defaultValue: label })) : (label),
        " ",
        React.createElement(Icon, { className: `${!enabled ? "focus-listbutton-disabled" : ""}`, icon: "cross", intent: Intent.NONE, onClick: onClick })));
};
//# sourceMappingURL=ListWithAction.js.map